// extracted by mini-css-extract-plugin
module.exports = {"board_charts_wrapper":"BoardCharts_board_charts_wrapper__xi1oS"};